import { faCirclePlus, faPen, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Switch } from "@mui/material";
import CommonTable from "common/CommonTable";
import React, { useEffect, useState } from "react";
import { getUserslist, updateUserStatus } from "services/apiService";
import DynamicButton from "../../common/DynamicButton";
import loadingImage from "../../assect/loadingSvg/loading.svg";
import CustomersCreate from "./CustomersCreate";
import toast from "react-hot-toast";

const CustomersList = () => {
  const [loader, setLoader] = useState(false);
  const [allUserList, setAllUserList] = useState([]);
  const [filteredUser, setFilteredUser] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpenCreate, setisOpenCreate] = useState(false);
  const [editingUserId, setEditingUserId] = useState<number | null>(null);
  const [updatedStatus, setUpdatedStatus] = useState<{
    [key: number]: boolean;
  }>({});
  const [editedUserData, setEditedUserData] = useState({
    id: null,
    full_name: "",
    phone_no: "",
    email_verify: 0,
  });

  const itemsPerPage = 10;

  useEffect(() => {
    fetchAllUsersList();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [userSearch]);

  const fetchAllUsersList = async () => {
    setLoader(true);
    try {
      const response = await getUserslist();
      setAllUserList(response.data);
      setFilteredUser(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoader(false);
  };

  const handleSearch = () => {
    const lowercasedSearch = userSearch.toLowerCase();
    const filtered = allUserList.filter(
      (user) =>
        user.email.toLowerCase().includes(lowercasedSearch) ||
        user.full_name.toLowerCase().includes(lowercasedSearch)
    );
    setFilteredUser(filtered);
    setCurrentPage(1);
  };

  const HandleClose = () => {
    setisOpenCreate(false);
  };

  const handleEditClick = (user: any) => {
    setEditingUserId(user.id);
    setUpdatedStatus({ [user.id]: user.is_active });
    setEditedUserData({
      id: user.id,
      full_name: user.full_name,
      phone_no: user.phone_no,
      email_verify: user.email_verify,
    });
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setEditedUserData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: name === "email_verify" ? Number(value) : value,
      };

      console.log("Updated Data:", updatedData);
      return updatedData;
    });
  };

  const handleStatusChange = (userId: number) => {
    setUpdatedStatus((prevStatus) => ({
      ...prevStatus,
      [userId]: !prevStatus[userId],
    }));
  };

  const handleSaveUser = async () => {
    try {
      const payload = {
        id: editedUserData.id,
        full_name: editedUserData.full_name,
        phone_no: Number(editedUserData.phone_no),
        email_verify: editedUserData.email_verify,
        is_active: updatedStatus[editedUserData.id] ? 1 : 0,
      };

      const response = await updateUserStatus(payload);
      if (response.status_code === 200) {
        toast.success("User updated successfully!");
        setEditingUserId(null);
        fetchAllUsersList();
      } else {
        toast.error("Failed to update user!");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Something went wrong!");
    }
  };

  const renderRow = (user: any, index: number) => (
    <tr
      key={index}
      onClick={() => handleEditClick(user)}
      style={{ cursor: "pointer" }}
    >
      <td>{index + 1}</td>
      <td>
        {editingUserId === user.id ? (
          <input
            type="text"
            name="full_name"
            value={editedUserData.full_name}
            onChange={handleInputChange}
            className="form-control"
          />
        ) : (
          user.full_name
        )}
      </td>
      <td>{user.email}</td>
      <td>
        {editingUserId === user.id ? (
          <input
            type="number"
            name="phone_no"
            value={editedUserData.phone_no}
            onChange={handleInputChange}
            className="form-control"
          />
        ) : (
          user.phone_no
        )}
      </td>
      <td>
        {editingUserId === user.id ? (
          <Switch
            checked={!!editedUserData.email_verify}
            onChange={(e) => {
              setEditedUserData((prevData) => ({
                ...prevData,
                email_verify: e.target.checked ? 1 : 0,
              }));
            }}
            color="primary"
          />
        ) : user.email_verify === 1 ? (
          "Yes"
        ) : (
          "No"
        )}
      </td>
      <td>
        {editingUserId === user.id ? (
          <Switch
            checked={updatedStatus[user.id] || false}
            onChange={() => handleStatusChange(user.id)}
          />
        ) : (
          <span style={{ color: user.is_active ? "green" : "red" }}>
            {user.is_active ? "Active" : "Inactive"}
          </span>
        )}
      </td>
      <td>
        {editingUserId === user.id ? (
          <DynamicButton
            icon={faSave}
            iconStyle={{ color: "#28a745" }}
            onClick={handleSaveUser}
            style={{ background: "none", cursor: "pointer", margin: "2px" }}
          />
        ) : (
          <DynamicButton
            icon={faPen}
            iconStyle={{ color: "#63E6BE" }}
            onClick={(e) => {
              e.stopPropagation();
              handleEditClick(user);
            }}
            style={{ background: "none", cursor: "pointer", margin: "2px" }}
          />
        )}
      </td>
    </tr>
  );

  const paginatedData = filteredUser.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button
          variant="contained"
          color="primary"
          onClick={() => setisOpenCreate(true)}
          sx={{ borderRadius: "0px" }}
        >
          <FontAwesomeIcon
            icon={faCirclePlus}
            style={{ marginRight: "10px" }}
          />
          Add Users
        </Button>
        <input
          type="text"
          placeholder="Search User..."
          className="form-control"
          style={{ maxWidth: "300px", boxShadow: "none" }}
          value={userSearch}
          onChange={(e) => setUserSearch(e.target.value)}
        />
      </div>

      <div className="product-table-content">
        {loader ? (
          <div className="text-center">
            <img src={loadingImage} width={150} height={150} alt="Loading..." />
          </div>
        ) : (
          <CommonTable
            data={paginatedData}
            isLoading={loader}
            headers={[
              "S.no",
              "Name",
              "Email",
              "Phone",
              "Email verify",
              "Status",
              "Action",
            ]}
            renderRow={renderRow}
          />
        )}
      </div>

      <CustomersCreate open={isOpenCreate} onClose={HandleClose} />
    </>
  );
};

export default CustomersList;
